import { render, staticRenderFns } from "./proComponent.vue?vue&type=template&id=6098eb08&scoped=true"
import script from "./proComponent.vue?vue&type=script&lang=js"
export * from "./proComponent.vue?vue&type=script&lang=js"
import style0 from "./proComponent.vue?vue&type=style&index=0&id=6098eb08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6098eb08",
  null
  
)

export default component.exports